




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class InfusionChangeDirection extends Vue {
  @Prop() readonly direction!: number;

  get show(): boolean {
    return this.direction !== undefined && this.direction !== null;
  }

  get icon(): string {
    if (this.direction < 0) return "caret-down-fill";
    else if (this.direction === 0) return "stop-fill";
    else if (this.direction > 0) return "caret-up-fill";

    return "";
  }
}
